import React, { useEffect, useState } from "react";
import useChatSoporte from "./useChatSoporte";
import useEsMovil from "./useEsMovil";
import BurbujaSoporte from "./BurbujaSoporte";
import ModalNuevoTicket from "./ModalNuevoTicket";
import { esAgenteBiwo } from "./agentesBiwo";

const BurbujaSoporteGlobal = ({
  headersToken,
  abierto,
  onCerrar,
  onNoLeidos,
  onAbrirVistaCompleta,
  usuarioId,
  esMaster,
  puedeRevisar,
}) => {
  const [modalNuevo, setModalNuevo] = useState(false);
  const [pestana, setPestana] = useState("tickets");
  const modoSoporte = esAgenteBiwo(usuarioId);
  const conPeticiones = !modoSoporte && !!puedeRevisar;
  const enPeticiones = conPeticiones && pestana === "peticiones";

  const chat = useChatSoporte({
    headersToken,
    chatAbierto: abierto && !enPeticiones,
    modoSoporte,
    listaActiva: abierto && !enPeticiones,
  });
  const peticiones = useChatSoporte({
    headersToken,
    chatAbierto: abierto && enPeticiones,
    modoPeticiones: true,
    listaActiva: abierto && enPeticiones,
    habilitado: conPeticiones,
  });
  const vista = enPeticiones ? peticiones : chat;
  const esMovil = useEsMovil();

  // El máster puede VER los reportes de sus usuarios hijos, pero no escribir
  // en su chat — el backend ya lo bloquea, esto solo oculta el composer.
  const soloLectura =
    !modoSoporte &&
    !enPeticiones &&
    !!esMaster &&
    !!chat.ticketActivo &&
    String(chat.ticketActivo.usuarioId?._id || chat.ticketActivo.usuarioId) !== String(usuarioId);

  const noLeidos = chat.noLeidos + (conPeticiones ? peticiones.noLeidos : 0);

  useEffect(() => {
    if (onNoLeidos) onNoLeidos(noLeidos);
  }, [noLeidos, onNoLeidos]);

  const alRevisarPeticion = () => {
    peticiones.volverALista();
    peticiones.cargarTickets();
  };

  return (
    <>
      <BurbujaSoporte
        abierto={abierto}
        onCerrar={onCerrar}
        tickets={vista.tickets}
        ticketActivo={vista.ticketActivo}
        mensajes={vista.mensajes}
        loadingTickets={vista.loadingTickets}
        loadingMensajes={vista.loadingMensajes}
        enviando={vista.enviando}
        seleccionarTicket={vista.seleccionarTicket}
        volverALista={vista.volverALista}
        enviarMensaje={vista.enviarMensaje}
        onNuevoTicket={() => setModalNuevo(true)}
        onAbrirVistaCompleta={onAbrirVistaCompleta}
        soloLectura={soloLectura}
        esMaster={!!esMaster}
        usuarioId={usuarioId}
        modoSoporte={modoSoporte}
        modoPeticiones={enPeticiones}
        pestanas={
          conPeticiones
            ? {
                valor: pestana,
                onChange: setPestana,
                noLeidosTickets: chat.noLeidos,
                noLeidosPeticiones: peticiones.noLeidos,
              }
            : null
        }
        headersToken={headersToken}
        onPeticionRevisada={alRevisarPeticion}
        esMovil={esMovil}
        respondiendo={chat.respondiendo}
        onResponderSubido={enPeticiones ? undefined : chat.responderSubido}
        busqueda={chat.busqueda}
        onBuscar={chat.setBusqueda}
        buscando={chat.buscando}
        totalRecords={chat.totalRecords}
        hayMas={chat.hayMas}
        cargandoMas={chat.cargandoMas}
        onCargarMas={chat.cargarMas}
      />

      <ModalNuevoTicket
        visible={modalNuevo}
        creando={chat.creando}
        onCancel={() => setModalNuevo(false)}
        onCrear={(formData, onExito) => {
          setPestana("tickets");
          chat.crearPreReporte(formData, onExito);
        }}
      />
    </>
  );
};

export default BurbujaSoporteGlobal;
